module.exports = "/_next/static/images/directionalDrillingForUtilityProjects-504c6ec51db29ecbd2f25324c4308bf3.webp";